import { Container, Typography } from '@cleartrip/ct-design-components'
import { useEffect, useState } from 'react'
import InputRange from 'react-input-range-rtl'
import RangeSlider from './RangeSlider'

function LayoverDurationFilter(props: any) {
  const { currentDuration, minInHours, maxInHours, onFilterChange, filterType, label, isRevamp = false } = props

  const [duration, setDuration] = useState({ min: minInHours, max: maxInHours })

  const onDurationValueChange = (durationValue: any) => {
    setDuration(durationValue)
  }
  useEffect(() => {
    setDuration(currentDuration)
  }, [currentDuration])

  const onDurationValueChangeComplete = () => {
    onFilterChange(filterType, duration)
  }

  const minLabel = duration?.min
  const maxLabel = duration?.max
  const valueText = `${minLabel} - ${maxLabel} hrs`

  return (
    <>
      <Container className='flex flex-middle'>
        <Typography
          variant='P2'
          color='subheading'
          className={isRevamp ? 'pb-2 mr-1' : 'pb-4 mr-1'}
        >{`${label}:`}</Typography>
        <Typography variant='P2' className={isRevamp ? 'pb-2' : 'pb-4 '}>
          {valueText}
        </Typography>
      </Container>
      {isRevamp ? (
        <RangeSlider
          ariaLabel={[`Minimum ${label}`, `Maximum ${label}`]}
          max={maxInHours}
          min={minInHours}
          value={[Number(duration?.min ?? minInHours), Number(duration?.max ?? maxInHours)]}
          onChange={([min, max]) => setDuration({ min, max })}
          onChangeComplete={([min, max]) => onFilterChange(filterType, { min, max })}
        />
      ) : (
        <div className='pl-1 pb-4 intl_inputRange' style={{ width: '90%' }}>
          <InputRange
            minValue={minInHours}
            maxValue={maxInHours}
            value={duration}
            onChange={onDurationValueChange}
            onChangeComplete={onDurationValueChangeComplete}
            step={1}
          />
        </div>
      )}
    </>
  )
}

export default LayoverDurationFilter
